jQuery(document).ready(function($) {
	var buttons = document.querySelectorAll('.wsk-import');
	buttons.forEach(function(button) {
		button.addEventListener('click', doImport);
	});

	progress_bar_ajax();

	function doImport(e) {
		// hide buttons to prevent double launch of process
		buttons.forEach(function(button) {
			button.style.display = 'none';
		});

		const data = {
			action: 'whisk_do_import',
			importer: e.target.id,
			nonce: window.whisk_import.nonce,
		};

		$.post( ajaxurl, data, function(response) {
			if (response.success) {
				// add mark to body in case process will finish earlier then progress bar will load
				document.querySelector('body').dataset.importRunning = response.data.importer;
				// go to server for progress bar data
				progress_bar_ajax();
			} else {
				document.querySelector('.whisk_message').textContent = response.data.message;
			}
		});
	}

	function progress_bar_ajax() {
		const data = {
			action: 'whisk_get_progress',
			nonce: window.whisk_import.nonce,
		};
		var message = document.querySelector('.whisk_message');

		$.post( ajaxurl, data, function(response) {
			if (response.success) {

				// process is finished or did not start
				if (response.data.progress === false) {
					const progress = document.querySelector('.progress');

					if (progress || document.querySelector('body').dataset.importRunning) {
						if (progress) {
							progress.remove();
						}

						// buttons.forEach(function(button) {
						// 	button.style.display = 'block';
						// });
						document.querySelector('body').dataset.importRunning = false;
						if (response.data.importer) {
							message.textContent = window.whisk_import.complete;
							const wrapClass = '.' + response.data.importer + '-wrap';
							const wrap = document.querySelector(wrapClass);
							wrap.querySelector('span').textContent = '';
						}
					}
					return;
				}

				// we have a process running
				buttons.forEach(function (button) {
					button.style.display = 'none';
				});
				message.textContent = window.whisk_import.inProgress;
				render_progress_bar(response.data);
				setTimeout(progress_bar_ajax, 5000);
			}
		});
	}

	function render_progress_bar(data) {
		const oldProgress = document.querySelector('.progress');
		const wrapper = document.querySelector('.' + data.importer + '-wrap');
		let progress = document.createElement('div');
		let progressInner = document.createElement('div');
		const widthPercents = (data.progress / data.total) * 100;

		progress.className = 'progress';
		progressInner.classList.add('progress-bar', 'progress-bar-striped', 'progress-bar-animated');
		progressInner.style.width = widthPercents + '%';
		if (oldProgress) {
			oldProgress.remove();
		}
		progress.append(progressInner);
		wrapper.append(progress);
	}
});
